var _g, _rect, _circle, _path, _path2, _path3, _path4, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdfc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 306,
    viewBox: "0 0 392 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_454_1527)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 37,
    width: 286,
    height: 200,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 52,
    width: 30,
    height: 15,
    rx: 7.5,
    fill: "#6C63FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 59.5,
    r: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 174H292V101H85V174Z",
    fill: "#9D1D27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.825 116.799H142.287V158.204H100.824L100.825 116.8V116.799ZM145.779 113.316L97.3319 113.313V161.687H145.779V113.315V113.316Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.26 129.145H137.851V121.229H105.26V129.145ZM105.26 153.771H113.187V145.855H105.26V153.771ZM105.26 141.458H125.519V133.542H105.26V141.458ZM158.111 137.94H161.634V121.229H158.111V137.94ZM167.961 124.052V134.745H170.938C174.211 134.745 174.961 133.497 174.961 129.342C174.961 124.915 174.483 124.052 170.575 124.052H167.961ZM171.393 121.259C176.529 121.259 178.369 123.483 178.369 129.318C178.369 134.927 176.416 137.539 171.369 137.539H164.598V121.259H171.393ZM180.983 121.259H192.436V124.052H184.346V127.867H191.414V130.659H184.346V137.539H180.983V121.259ZM208.117 132.18C207.889 135.358 206.116 137.902 201.094 137.902C196.185 137.902 193.708 135.473 193.708 129.478C193.708 123.62 196.05 120.896 201.116 120.896C205.117 120.896 207.571 122.598 208.117 126.322H204.753C204.366 124.87 203.89 123.756 201.116 123.756C198.344 123.756 197.116 125.414 197.116 129.774C197.116 133.156 198.026 135.043 201.161 135.043C203.414 135.043 204.481 134.337 204.753 132.18H208.117ZM217.07 121.259H228.524V124.052H220.433V127.867H227.502V130.659H220.433V137.539H217.07V121.259Z",
    fill: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_454_1527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 101,
    width: 207,
    height: 73
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85 174H292V101H85V174Z",
    fill: "#FEFEFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_454_1527)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.705 137.539H234.068V121.26H230.705V137.539ZM240.591 124.052V128.342H243.614C246.318 128.342 247.225 128.071 247.225 126.027C247.225 124.392 246.658 124.052 243.817 124.052H240.591ZM237.228 121.259H244.296C247.68 121.259 250.636 121.349 250.636 126.14C250.636 129.318 249.317 130.499 247.454 130.932L251.704 137.539H247.613L243.614 131.136H240.591V137.539H237.228V121.259ZM255.954 132.43C256.089 134.133 256.341 135.042 259.567 135.042C261.272 135.042 262.521 134.791 262.521 133.133C262.521 132.136 262.066 131.59 260.636 131.203L256.681 130.137C254.704 129.616 252.953 128.662 252.953 125.687C252.953 123.348 254.022 120.896 259.067 120.896C263.861 120.896 265.361 123.121 265.431 126.027H262.066C261.906 124.666 261.839 123.755 258.928 123.755C257.227 123.755 256.363 124.075 256.363 125.369C256.363 126.55 257.067 126.89 258.021 127.141L261.657 128.117C263.976 128.728 265.929 129.637 265.929 132.882C265.929 137.471 261.999 137.902 259.567 137.902C254.249 137.902 252.794 135.812 252.591 132.43H255.954ZM271.634 124.12H266.726V121.26H279.882V124.12H274.997V137.537H271.634V124.12ZM161.439 154.791V159.082H164.462C167.53 159.082 168.21 158.856 168.21 156.994C168.21 155.041 167.575 154.791 165.12 154.791H161.439H161.439ZM161.439 148.39V151.999H165.211C167.235 151.999 167.734 151.75 167.734 150.069C167.734 148.708 167.415 148.389 164.576 148.389H161.44L161.439 148.39ZM166.029 145.597C169.234 145.597 170.983 146.731 170.983 149.82C170.983 152.34 169.825 152.862 169.121 153.156C171.121 153.928 171.62 155.473 171.62 157.176C171.62 159.855 170.392 161.875 165.893 161.875H158.076V145.597H166.029ZM180.915 156.359L178.71 156.722C177.506 156.904 176.643 157.153 176.643 158.425C176.643 159.333 177.096 159.833 178.505 159.833C180.437 159.833 180.915 158.788 180.915 157.313V156.359ZM173.847 153.544C174.006 150.454 175.776 149.615 179.005 149.615C182.323 149.615 184.072 150.5 184.072 153.111V161.875H181.051V160.966C180.437 161.602 179.277 162.171 177.37 162.171C174.505 162.171 173.483 160.9 173.483 158.857C173.483 156.201 175.21 155.201 176.961 154.928L180.915 154.314V153.589C180.915 152.475 180.345 152.157 178.869 152.157C177.301 152.157 176.983 152.52 176.824 153.543H173.847V153.544ZM194.572 154.996C194.572 153.158 194.55 152.204 192.528 152.204C190.276 152.204 190.027 153.385 190.027 156.199V161.876H186.868V149.91H189.869V151.454C190.73 150.295 191.664 149.616 193.868 149.616C196.936 149.616 197.731 150.931 197.731 154.565V161.876H194.572V154.996ZM200.776 145.597H203.936V154.337L207.821 149.91H211.707L207.526 154.451L211.867 161.876H208.208L205.3 156.677L203.936 158.084V161.876H200.776V145.597Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_454_1527",
    x: 0,
    y: 0,
    width: 392,
    height: 306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_454_1527"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_454_1527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_454_1527",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdfc);
export default __webpack_public_path__ + "static/media/idfc.67fe52f3377c3c7a6fe19d327e9ffa49.svg";
export { ForwardRef as ReactComponent };